import * as fs from "node:fs";
import * as path from "node:path";

import { sha256File, sha256Text } from "../../common.js";
import type { VideoSourceEpisodeIdentity } from "../../domain/ingest/video-source-evolution.js";
import type { VideoEpisode } from "./video-discovery.js";

export function snapshotVideoSource(
  episodes: VideoEpisode[],
  previous: readonly VideoSourceEpisodeIdentity[] = [],
  previousVerifiedAt?: string,
): VideoSourceEpisodeIdentity[] {
  const priorByEpisode = new Map(previous.map((item) => [item.episode, item]));
  const verifiedAtMs = previousVerifiedAt ? Date.parse(previousVerifiedAt) : Number.NaN;
  return episodes.map((episode) => {
    const absolutePath = path.resolve(episode.path);
    const stat = fs.statSync(absolutePath);
    const sizeBytes = stat.size;
    const mtimeMs = Math.trunc(stat.mtimeMs);
    const prior = priorByEpisode.get(episode.episode);
    const unchangedByMetadata = prior
      && prior.size_bytes === sizeBytes
      && prior.mtime_ms === mtimeMs;
    const unchangedSinceLegacyVerification = prior
      && prior.size_bytes === undefined
      && prior.mtime_ms === undefined
      && prior.path === absolutePath
      && Number.isFinite(verifiedAtMs)
      && stat.mtimeMs <= verifiedAtMs;
    const sha256 = prior
      && prior.ext === episode.ext
      && prior.mime === episode.mime
      && (unchangedByMetadata || unchangedSinceLegacyVerification)
      ? prior.sha256
      : sha256File(absolutePath);
    return {
      episode: episode.episode,
      path: absolutePath,
      ext: episode.ext,
      mime: episode.mime,
      sha256,
      size_bytes: sizeBytes,
      mtime_ms: mtimeMs,
    };
  });
}

export function videoSourceFingerprint(episodes: VideoSourceEpisodeIdentity[]): string {
  return sha256Text(JSON.stringify(episodes.map((episode) => ({
    episode: episode.episode,
    ext: episode.ext,
    mime: episode.mime,
    sha256: episode.sha256,
  }))));
}
